import React from 'react';
import { AiOutlineCheck } from 'react-icons/ai';

const etapas = ['Espaço', 'Data', 'Pagamento'];

export default function Stepper({ etapaAtual }: { etapaAtual: number }) {
  return (
    <ol className='flex items-center w-full max-w-md mx-auto mb-8' aria-label='Etapas da reserva'>
      {etapas.map((etapa, index) => {
        const concluida = index < etapaAtual;
        const atual = index === etapaAtual;

        return (
          <li
            key={etapa}
            className={`flex items-center ${index < etapas.length - 1 ? 'flex-1' : ''}`}
            aria-current={atual ? 'step' : undefined}
          >
            <div className='flex flex-col items-center gap-1'>
              <span
                className={[
                  'flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold transition-colors',
                  concluida && 'bg-zinc-900 text-white',
                  atual && 'bg-zinc-900 text-white ring-4 ring-zinc-200',
                  !concluida && !atual && 'bg-zinc-100 text-zinc-400',
                ].filter(Boolean).join(' ')}
              >
                {concluida ? <AiOutlineCheck aria-hidden='true' /> : index + 1}
              </span>
              <span className={`text-xs ${atual || concluida ? 'text-zinc-900 font-medium' : 'text-zinc-400'}`}>
                {etapa}
              </span>
            </div>
            {index < etapas.length - 1 && (
              <div className={`flex-1 h-0.5 mx-2 mb-5 rounded ${concluida ? 'bg-zinc-900' : 'bg-zinc-200'}`} />
            )}
          </li>
        );
      })}
    </ol>
  );
}
